import React from "react";
import { motion } from "framer-motion";

const cardVariants = {
	hover: {
		scale: 1.1,
	},
	transition: {
		duration: 0.5,
	},
};

const Card = ({ title, icon, color, level }) => {
	return (
		<motion.div
			variants={cardVariants}
			whileHover="hover"
			transition="transition"
			className="max-w-sm border border-green-800 rounded-2xl shadow-md">
			<motion.div className="p-5 flex flex-col gap-2 items-center justify-center text-3xl lg:text-6xl">
				<button className={`${color}`}>{icon}</button>
				<h1 className="text-sm lg:text-xl font-bold">{title}</h1>
			</motion.div>
		</motion.div>
	);
};

export default Card;
